import { useState } from "react"
import { StepProps } from "../../../../components/Stepper"
import { AuthData } from "../../../../types/steps/auth"
import MaskInput, { masks } from "../../../../features/auth/MaskInput"
import { useAuth } from "../../../../hooks/useAuth"
import { useAuthModalClose } from "../../../../features/auth/useAuthModalClose"
import AuthLegalLink from "../../../../features/auth/AuthLegalLink"
import AuthSheetLayout, { AuthSheetButton } from "../../../../features/auth/AuthSheetLayout"
import { AuthCaption } from "../../../../features/auth/AuthShell"
import { authCaptionStyle, authLinkClass } from "../../../../features/auth/authTheme"
import { openTelegramBot } from "../../../../lib/telegram"

export default function Phone({ navigate, params }: StepProps<AuthData>) {
    const [phone, setPhone] = useState(params.phone || "")
    const [loading, setLoading] = useState(false)
    const { sendCode } = useAuth()
    const closeAuthModal = useAuthModalClose()
    const disabled = phone.length < masks["phone"].maxDigits || loading

    type AuthType = "telegram" | "sms" | "newtel_call"
    type Step = "code" | "telegram" | "call"

    const nextStep: Record<AuthType, Step> = {
        telegram: "telegram",
        sms: "code",
        newtel_call: "call",
    }

    const handleNextStep = async (type: AuthType) => {
        try {
            setLoading(true)
            // iOS Safari требует открытие Telegram синхронно из клика, до await
            if (type === "telegram") {
                openTelegramBot()
            }
            const { registered, resData } = await sendCode(phone, type)
            navigate(nextStep[type], { phone, type, registered, resData, reauth: params.reauth })
        } finally {
            setLoading(false)
        }
    }

    const skipButton = params.reauth ? (
        <button
            type="button"
            onClick={closeAuthModal}
            className="cursor-pointer py-1 text-[13px] text-white/60 underline-offset-2 transition-colors hover:text-white hover:underline"
            style={authCaptionStyle}>
            Пропустить
        </button>
    ) : null

    return (
        <AuthSheetLayout
            title="Войти"
            footer={
                <>
                    <AuthSheetButton variant="secondary" disabled={disabled} onClick={() => handleNextStep("newtel_call")}>
                        Вход звонком
                    </AuthSheetButton>
                    <AuthSheetButton variant="primary" disabled={disabled} onClick={() => handleNextStep("telegram")}>
                        Войти через Telegram
                    </AuthSheetButton>
                    {skipButton ? <div className="flex justify-center md:hidden">{skipButton}</div> : null}
                </>
            }>
            <div className="flex w-full justify-center overflow-visible">
                <MaskInput digits={phone} setDigits={setPhone} type="phone" centered autoFocus />
            </div>
            {skipButton ? <div className="hidden justify-center md:flex">{skipButton}</div> : null}
            <AuthCaption className="text-left">
                Авторизуясь, Вы соглашаетесь с{" "}
                <AuthLegalLink to="/personal-data" className={authLinkClass}>
                    положением об обработке персональных данных (152-ФЗ)
                </AuthLegalLink>
                ,{" "}
                <AuthLegalLink to="/privacy" className={authLinkClass}>
                    политикой конфиденциальности
                </AuthLegalLink>{" "}
                и{" "}
                <AuthLegalLink to="/terms" className={authLinkClass}>
                    пользовательским соглашением
                </AuthLegalLink>
            </AuthCaption>
        </AuthSheetLayout>
    )
}
